import {
  Component,
  ElementRef,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { _ButtonBase } from './button-base.component';
import { ButtonSize, BUTTON_HOST_ATTRIBUTES, BUTTON_SIZES } from './button.types';
import { ButtonIconSizeMap } from '../shared/theme.types';
import { IconComponent } from '../icon/icon.component';

/**
 * @class
 * @description
 * ButtonComponent is currently under development.
 * Use with caution as it may exhibit unexpected behaviors.
 *
 * @see Examples on [README](./README.md)
 *
 * Inspired by material's button
 * @see https://material.angular.io/components/button/api
 */
@Component({
    selector: `
    yoo-button,
    button[yoo-button],
  `,
    imports: [
        CommonModule,
        IconComponent,
    ],
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ButtonComponent extends _ButtonBase {

  @Input() iconRight?: string = '';
  @Input() iconLeft?: string = '';
  @Input() disabled?: boolean = false;
  @Input() iconAnimation?: any = undefined;
  @Input() block?: boolean = false;

  sizes = BUTTON_SIZES;
  sizeMap = ButtonIconSizeMap;

  iconSize!: number;

  constructor(
    elementRef: ElementRef,
  ) {
    super(elementRef);

    // For each of the variant selectors that is present in the button's host
    // attributes, add the correct corresponding class.
    for (const attr of BUTTON_HOST_ATTRIBUTES) {
      const buttonRef = (this.getHostElement() as HTMLElement);

      if (this.hasHostAttributes(attr)) {
        buttonRef.classList.add(`button-${attr}`);

        if (this.sizes.includes(attr as ButtonSize)) {
          this.iconSize = this.sizeMap[attr as ButtonSize] as number;
        } else {
          buttonRef.classList.add('button-medium');
          this.iconSize = this.sizeMap['small'] as number;
        }
      }
    }

    if (this.hasHostAttributes('disabled')) {
      this.disabled = true;
    }

    if (this.disabled) {
      this.getHostElement().classList.add('button-disabled');
    }

    // Add a class that applies to all buttons. This makes it easier to target if somebody
    // wants to target all buttons. We do it here rather than `host` to ensure that
    // the class is applied to derived classes.
    this.getHostElement().classList.add('button-base');
  }

  private getHostElement(): HTMLElement {
    return this._elementRef.nativeElement;
  }

  /** Gets whether the button has one of the given attributes. */
  private hasHostAttributes(...attributes: string[]): boolean {
    return attributes.some((attribute) =>
      this.getHostElement().hasAttribute(attribute),
    );
  }
}
